import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  showInvoicePDF(event) {
    event.preventDefault();
    const url = this.data.get("url");
    const checkUrl = this.data.get("check-url");

    axios
      .get(checkUrl)
      .then(response => {
        if (response.data.file_exist) {
          window.open(url, "_blank");
        } else {
          bootbox.alert({
            message: "The pdf is not available at this time",
            closeButton: false
          });
        }
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }
}
